import { Component, Inject, Renderer2, RendererFactory2, TemplateRef } from "@angular/core";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Observable, of } from "rxjs";
import { isNullOrUndefined } from "../../utils";

export interface SettingsModalData {
  tabs: SettingsModalTab[];
  title?: string;
  canSave?: boolean;
  showClose?: boolean;
  activeTabIndex?: number;
  valid$?: Observable<boolean>;
};

export interface SettingsModalTab {
  title: string;
  icon?: string;
  content: TemplateRef<any>;
};

@Component({
  templateUrl: 'settings-modal.dialog.html',
  styleUrls: ['settings-modal.dialog.scss'],
  standalone: false
})
export class SettingsModalDialog {
  title: string;
  canSave = true;
  showClose = true;
  activeTabIndex = 0;
  valid$: Observable<boolean>;

  tabs: TabState[];

  constructor(
    public dialogRef: MatDialogRef<SettingsModalData>,
    @Inject(MAT_DIALOG_DATA) public data: SettingsModalData) {
    this.dialogRef.addPanelClass('settings-modal-dialog-panel');

    this.title = this.data.title ?? 'Settings';
    this.canSave = this.data.canSave ?? true;
    this.showClose = this.data.showClose ?? true;
    this.activeTabIndex = this.data.activeTabIndex ?? 0;
    this.valid$ = this.data.valid$ ?? of(true);

    this.tabs = this.data.tabs.map((t, i) => {
      let tabState = <TabState>{
        ...t,
        noContent: false,
        contentIsTemplateRef: false
      };

      if (!isNullOrUndefined(t.content)) {
        tabState.content = t.content;
        tabState.contentIsTemplateRef = t.content instanceof TemplateRef;
      }

      return tabState;
    });
  }

  close(result?: boolean) {
    this.dialogRef.close(result);
  }

  setActiveTab(index: number) {
    this.activeTabIndex = index;
  }
}

interface TabState extends SettingsModalTab {
  contentIsTemplateRef: boolean;
};
